import * as React from "react";
import { ChevronRight, Landmark, Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TokohSeniorHero() {
  return <section id="tokohseniorhero" className="zona-pp-hero relative w-full bg-zinc-950 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-zinc-950/80 lg:bg-gradient-to-r lg:from-zinc-950 lg:via-zinc-950/90 lg:to-transparent z-10 pointer-events-none"></div>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/tokoh_senior_hero_background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/tokoh_senior_hero_background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/tokoh_senior_hero_background.png-wvc-sizes" alt="Jajaran Tokoh dan Senior Pemuda Pancasila" className="w-full h-full object-cover object-right lg:object-right-top opacity-60 lg:opacity-100" loading="lazy" />
      </div>

      {}
      <div className="container mx-auto px-4 py-16 md:py-24 lg:py-32 relative z-20">
        <div className="max-w-3xl">
          {}
          <nav className="flex items-center gap-2 text-sm text-zinc-400 mb-6 font-medium" aria-label="Breadcrumb">
            <Link to="/PPZonePage" className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-md">
              Beranda Zona PP
            </Link>
            <ChevronRight className="w-4 h-4 shrink-0" />
            <span className="text-zinc-100" aria-current="page">
              Tokoh & Senior
            </span>
          </nav>

          {}
          <h1 className="zona-pp-title text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-default tracking-tight">
            Tokoh & Senior
          </h1>
          
          <p className="text-lg md:text-xl text-zinc-300 mb-10 max-w-2xl leading-relaxed">
            Mengenal para tokoh, pendiri, ketua, senior dan kader Pemuda Pancasila tingkat nasional hingga wilayah berdasarkan data resmi dan terverifikasi.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground border-none h-14 px-8 text-base rounded-md shadow-md">
              <Link to="#nasional">
                <Landmark className="w-5 h-5 mr-2 shrink-0" />
                Nasional
              </Link>
            </Button>
            
            <Button asChild size="lg" variant="outline" className="bg-transparent border-zinc-600 text-white hover:bg-zinc-800 hover:text-white hover:border-zinc-500 h-14 px-8 text-base rounded-md shadow-sm">
              <Link to="#direktori-wilayah">
                <Map className="w-5 h-5 mr-2 shrink-0" />
                Direktori Wilayah
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}